import React from 'react';
import styled from 'styled-components';
import CenterSearch from './CenterSearch';
import LogoTagline from '@sls-react/components/Chrome/LogoTagline';
import HomePageLink from '@sls-react/components/Links/HomePageLink';
import UserSection from '@sls-react/components/Chrome/Header/Desktop/UserSection';
import BannerCollection from '@sls-react/components/Chrome/Banners/BannerCollection';
import BaseHeader from '@sls-react/components/Chrome/Header/BaseHeader';
import DesktopHeaderCategoryNavigationRow from '@sls-react/components/Chrome/Header/Desktop/DesktopHeaderCategoryNavigationRow';

const DesktopNav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 32px 0;
`;

const DesktopHeader: React.FC = () => (
  <BaseHeader id="header">
    <BannerCollection />
    <DesktopNav>
      <HomePageLink>
        <LogoTagline />
      </HomePageLink>

      <CenterSearch />

      <UserSection />
    </DesktopNav>

    <DesktopHeaderCategoryNavigationRow />
  </BaseHeader>
);

export default DesktopHeader;
